import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { devcontainersEntityCard } from './extensions/DevcontainersCard';

export const devcontainersCatalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [devcontainersEntityCard],
});